<template>
    <ul :class="node.klass || klass || 'node'" :type="node.type" :level="node.level" v-if="node">
        <li>
            <div v-if="node.value" class="node-value">
                <span class="prefix" @click.prevent="app.toggleNode(node, toggler)" v-html="prefix || app.prefix(node.type, node.level)"></span>
                <span class="value" v-html="app.htmlify(app.todoify(node.value))"></span>
                <span class="expander" v-if="isExpandable" @click.prevent="app.toggleNode(node, toggler)">...</span>
            </div>

            <div v-if="!toggler && node.isExpanded">
                <slot v-if="$slots.default"></slot>

                <div v-else>
                    <div class="node-content" v-html="app.htmlify(node.content)"></div>

                    <node
                        v-for="(n, i) in node.children"
                        :key="'node-' + i"
                        :node="n"
                        :app="app"
                    />

                    <node
                        v-if="remoteFiles"
                        :node="remoteFiles"
                        :app="app"
                    >
                        <ul>
                            <li v-for="file in remoteFiles.files" :key="file.key">
                                <a href="javascript:;" @click="download(file)">
                                    <span class="prefix" v-html="app.prefix('headline', node.level + 2)"></span>
                                    {{file.name}}
                                </a>
                            </li>
                        </ul>
                    </node>
                </div>
            </div>
        </li>
    </ul>
</template>

<script>
import NodeMixin from './mixin';

function stripTodo(str) {
    return (str || '').replace(/^[A-Z]{4,7}\s/, '');
}

function getPath(node) {
    var arr = [stripTodo(node.value)];

    while (node.parent) {
        node = node.parent;

        if (typeof node.value !== 'undefined') {
            arr.unshift(stripTodo(node.value));
        }
    }

    return arr.join('/');
}

export default {
    name: 'node',
    mixins: [NodeMixin],
    props: ['toggler', 'prefix', 'klass'],
    data() {
        return {
            remoteFiles: undefined
        };
    },
    mounted() {
        var _ = this;

        if (_.node.isExpanded) {
            _.fetchFiles();
        }
    },
    watch: {
        'node.isExpanded'(value) {
            var _ = this;

            if (!value || !_.node || _.remoteFiles || _.node.files) {
                return;
            }

            _.fetchFiles();
        }
    },
    computed: {
        isExpandable() {
            var _ = this;

            return !_.node.isExpanded && (
                _.remoteFiles ||
                (
                    _.node.content &&
                    _.node.content.length
                ) || (
                    _.node.children &&
                    _.node.children.length
                ) || (
                    _.node.files &&
                    _.node.files.length
                )
            );
        }
    },
    methods: {
        download(file) {
            var _ = this;

            _.app.connection.downloadURL(file.key, function(err, url) {
                if (err) {
                    return alert(err);
                }

                var a = document.createElement('a');

                a.target = '_blank';
                a.href = url;

                a.click();
            });
        },

        isFetchableNode(nodeType) {
            return nodeType === 'headline' || nodeType === 'root';
        },

        fetchFiles() {
            var _ = this,
                path = getPath(_.node);

            if (!_.app.connection || !_.isFetchableNode(_.node.type)) {
                return;
            }

            _.app.connection.list(path, function(err, data) {
                if (data && data.folders.length) {
                    for (var i = data.folders.length - 1; i >= 0; i--) {
                        if (_.node.children.find(function(child) {
                            return child.value === data.folders[i].name;
                        })) {
                            continue;
                        }

                        _.node.children.push({
                            type: 'headline',
                            level: (_.node.level || 0) + 1,
                            value: data.folders[i].name,
                            children: [],
                            loading: false,
                            isExpanded: false,
                            parent: _.node
                        });
                    }
                }

                var nonOrgFiles = data.files.filter(function(file) {
                    return file.key.indexOf('index.org') === -1;
                });

                if (data && nonOrgFiles.length) {
                    _.remoteFiles = {
                        type: 'headline',
                        level: (_.node.level || 0) + 1,
                        value: 'Files',
                        children: [],
                        files: nonOrgFiles,
                        loading: true,
                        isExpanded: false,
                        parent: _.node
                    };
                }
            });
        }
    }
};
</script>
